export const APP_NAME = 'HAKUOU Portal'
